import { goCardlessAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { goCardlessAPIUrls } from '../data';

type Response = {
  authorize_url: string;
};

export type ConnectGoCardless = {
  params: never;
  response: Response;
  return: Response;
};

export const connectGoCardless = withLogger(
  async (_params?: null): Promise<Response> => {
    const response = await goCardlessAxiosClient.get<Response>(
      goCardlessAPIUrls.connect,
    );

    return response.data;
  },
);
